export default __webpack_public_path__ + "static/media/user.aa5d0453.png";